import { createClient } from '@supabase/supabase-js';

// IMPORTANT: VITE_SUPABASE_ANON_KEY must be the LEGACY anon key (long JWT string),
// NOT the new publishable key (sb_publishable_...). Go to Supabase Dashboard → Settings → API
// → click "Legacy anon, service_role API keys" tab → copy the "anon" key.
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://placeholder.supabase.co';
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'placeholder_key';

export const supabase = createClient(supabaseUrl, supabaseKey);
